import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "./pages/NotFound";
import Header from './pages/Header';
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import Comandi from "./pages/Comandi";
import ListaSiti from "./pages/ListaSiti";
import Stampa from "./pages/Stampa";
import axios from "axios";
import {baseUrl} from  './library/comoda'
import {config} from  './library/comoda'

function App() {
  const [loggato, setloggato] = useState<boolean>(false);
  const  checkLoggato = async (token : string, utente : string) =>{
    const response = await axios.post(baseUrl+'login.php',
     {token, utente},
      config
      )
      setloggato(response.data.valido);
  };
   useEffect(() => {
      const fetchData = async () => {
        try {
         checkLoggato(String(localStorage.getItem('token')),String(localStorage.getItem('utente')));
        
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
  
      fetchData();
    }, [loggato]); // Runs only once after the initial render.
  
  
  return (
    <Router>
      <Header loggedIn={loggato} /> 
      <main>   
        <Routes>
        <Route path="/login" element={<Login />} />  
        <Route path="/" element={<Login />} />  
        <Route path="/dashboard" element={loggato ? <Dashboard /> : <Login />} />
        <Route path="/comandi" element={loggato ? <Comandi /> : <Login />} />
        <Route path="/upload" element={loggato ? <Upload /> : <Login />} />
        <Route path="/ListaSiti" element={loggato ? <ListaSiti /> : <Login />} />
        <Route path="/Stampa" element={loggato ? <Stampa /> : <Login />} />
        <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </Router>

  );
}

export default App;

